<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      :id="`input-shipping_address_state`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractSignupTextInput from "../core/AbstractSignupTextInput";
import BaseInputMixin from "@/mixins/signupInputMixin";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "ShippingState",
  components: {InputWidget, AbstractSignupTextInput},
  mixins: [BaseInputMixin('shipping_address.state')],

  data() {
    return {
      name: 'shipping_address.state',
      defaultLabel: this.$t("State")
    }
  }
}
</script>

<style scoped>

</style>
